<template>
    <div class="bibliografia">
        
        <page titolo="bibliografia" ref="bib"> 
            <template>
                <big-page titolo="Chi siamo e ringraziamenti" >
                    <template #testo>
                        <p class="title"><strong style="color: var(--secondary-color);">Chi siamo</strong></p> 
                        <p class="animation_text" ref="animation_text">Ricerca e Sito Web realizzati da:<br> 
                            <a href="mailto:emmanuelanansi@hotmail.com">Emmanuel Anansi</a>, <br> 
                            <a href="mailto://elaamraoui.youssef@outlook.com">Youssef El Aamraoui</a>, <br> 
                            <a href="mailto://domenicopopolizio9501@gmail.com">Domenico Popolizio</a>, <br> 
                            <a href="mailto://giulia.foglio@studenti.fauser.edu">Giulia Foglio</a>, <br> 
                            <a href="mailto://marcello.mazzucchi@studenti.fauser.edu">Marcello Mazzuchi</a>, <br> 
                        studenti della classi 5BIN nell'A.S. 2019/2020 presso <a href="fauser.edu" target="_blank">ITT G. Fauser</a> di Novara,
                        con il coordinamento della Prof.ssa <a href="mailto://cardano@docenti.fauser.edu">Anna Maria Cardano</a> per il Progetto di storia contemporanea del Consiglio Regionale del Piemonte.</p>

                        <br><br><br>

                        <p class="title"><strong style="color: var(--secondary-color);">Ringraziamenti</strong></p> 
                        <p class="animation_text" ref="animation_text">Ringraziamo:<br>
                        Archivio di Stato-Novara, Biblioteca Civica Carlo Negroni-Novara, Istituto Storico della Resistenza-Novara, 
Anastasiya Tymofyeyeva, Elena Mastretta, Giuliana Manica, Pierluigi Tolardo, Roberto Fuligni
                        </p>

                        <br><br><br>

                        
                    </template>
                                
                    <template #media> 

                    </template>
                </big-page>
            </template>
        </page>
    </div>
</template>

<script>
import BigPage from '../components/BigPage';
import Page from '../components/Page';
export default {
    name: 'bibliografia',
    components: {
        BigPage, Page
    },
    mounted() {
        this.$refs.bib.enable();
    }
}
</script>

<style scoped>

    .bibliografia {
        height: 100vh;
    }
    .to-orologio{
    position: absolute;
    z-index: 20;
    bottom: 2.5%;
    right: 5%;
    color: white;
    transition:0.4s all;
    text-decoration: none;
    }
    .to-orologio:hover {
    color: var(--secondary-color);
    transition:0.4s all;
    text-decoration: underline;

    }

    .big-page[data-v-b3b2d3a2] {
    width: 100%;
    height: 100vh;
    position: relative;
    color: var(--primary-color);
    }
</style>
